module.exports = __webpack_public_path__ + "img/thankyou.11d49e75.svg";